import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../../broker-audit-declaration.service';
import { StartFunctionService } from '../../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../../shared/utils/CurrentPageWatcher';
import { StorageService } from '../../../../shared/security/StorageService';
import { WorkflowModel } from '../../../../model/workflowModel';
import { SubmitBrokerAuditQuestionnaireRequestModel } from '../../../../model/submitBrokerAuditQuestionnaireRequestModel';
import { MessageModel } from '../../../../model/models';
import { StartFunctionResponseModel } from '../../../../model/startFunctionResponseModel';
import { BadQuestionnaireModel } from '../../../../model/badQuestionnaireModel';

@Component({
  selector: 'app-bad-questionnaire-additional-comment',
  templateUrl: './bad-questionnaire-additional-comment.component.html',
  styleUrls: ['./bad-questionnaire-additional-comment.component.css']
})
export class BadQuestionnaireAdditionalCommentComponent implements OnInit, OnDestroy {

  workflow: WorkflowModel = new WorkflowModel();
  badQuestionnaireDataModel : BadQuestionnaireModel;
  submitBrokerAuditQuestionnaireRequestModel : SubmitBrokerAuditQuestionnaireRequestModel = new SubmitBrokerAuditQuestionnaireRequestModel();

  userMessages: Array<MessageModel> = [];
  startFunction: StartFunctionResponseModel;

  constructor( private router : Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private startFunctionService : StartFunctionService,
    private currentPageWatcher : CurrentPageWatcherService,
    private storageService : StorageService) { }
  

  ngOnInit() {
    
    this.startFunction = this.storageService.getStartFunctionData();

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
    this.badQuestionnaireDataModel = this.brokerAuditDeclarationService.badQuestionnaireDataModel;
  }



  submitBADQuestionnaire(){

    this.submitBrokerAuditQuestionnaireRequestModel.WorkflowID = this.workflow.WorkflowID;
    this.submitBrokerAuditQuestionnaireRequestModel.CurrentStepIndex = this.workflow.CurrentStepIndex;
    this.submitBrokerAuditQuestionnaireRequestModel.Answers = this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers;
    this.submitBrokerAuditQuestionnaireRequestModel.SubmitAsDraft = false;
    this.submitBrokerAuditQuestionnaireRequestModel.AdditionalInformationComments = this.badQuestionnaireDataModel.AdditionalInformationComments;
    // this.brokerAuditDeclarationService.badQuestionnaireDataModel.AdditionalInformationComments = this.submitBrokerAuditQuestionnaireRequestModel.AdditionalInformationComments;

    console.log("submitBrokerAuditQuestionnaireRequestModel : ",this.submitBrokerAuditQuestionnaireRequestModel);
    this.brokerAuditDeclarationService.submitBrokerAuditDeclarationQuestionnaire( this.submitBrokerAuditQuestionnaireRequestModel)
    .subscribe(response=>{
      console.log("submitBrokerAuditDeclarationQuestionnaire response : ",response);
      response.UserMessages.forEach(msg => {
        this.userMessages.push(msg);
      })
      this.currentPageWatcher.sendUserMessages(this.userMessages);

      if (response.Summary == 0) {
        //save submitBrokerAuditQuestionnaireRequestModel in brokerAuditDeclarationService
        this.brokerAuditDeclarationService.submitBrokerAuditQuestionnaireRequestModel = this.submitBrokerAuditQuestionnaireRequestModel;
        //update BAD workflow informations (brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel is shared)
        this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = response.Workflow;
        //save startFunction with updated workflow in localstorage
        this.brokerAuditDeclarationService.updateStartFunction(this.startFunction);
        
        this.router.navigate(['/brokerAuditDeclarationReview']).then(()=>{
          this.startFunctionService.getNotifyStepInProgress().emit(true);
  
        })
       
        this.userMessages = [];
      }
      if (response.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];

      }

      if (response.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }
    },
    err=>{
      console.log("error: ",err);
    });
  }

  goBack(){
    //get last brokerADQuestionnaire section
    let sectionsList = this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList;
    let questListSectionId = sectionsList[sectionsList.length - 1];
    this.router.navigate(['/questionnaireAuditDeclarationSection', questListSectionId]);
  }

  //back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.goBack();
  }

  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-additional-comment/bad-questionnaire-additional-comment.component.ts